var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-notification',{staticClass:"upgrade-notification",attrs:{"closable":false,"has-icon":"","icon":"info-circle","icon-pack":"fas","icon-size":"is-small","size":"is-small"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }